const objectToArray = (object) => {
    const keys = Object.keys(object);

    return keys.map((key) => ({ [key.toString()]: object[key] }));
};

export default objectToArray;
